import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';

const SzenenvorschlagPage = ({ projectId }) => {
  // States für verschiedene Daten
  const [probedaten, setProbedaten] = useState([]);
  const [scenes, setScenes] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [absences, setAbsences] = useState([]);
  const [teamAvailability, setTeamAvailability] = useState([]);
  
  // States für Probenvorschläge und ausgewählte Szenen
  const [probenvorschlaege, setProbenvorschlaege] = useState([]);
  const [ausgewaehlteSzenen, setAusgewaehlteSzenen] = useState([]);
  const [selectedProbetermin, setSelectedProbetermin] = useState('');
  const [selectedZeiteinheit, setSelectedZeiteinheit] = useState('');
  const [zeiteinheiten, setZeiteinheiten] = useState([]);

  const formatDate = (dateStr) => {
    // Konvertiert das Datum in das DD.MM.YYYY Format
    if (!dateStr) return '';
    if (dateStr.includes('.')) return dateStr; // Bereits im richtigen Format
    
    const parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;
    
    return `${parts[2]}.${parts[1]}.${parts[0]}`;
  };

  const parseDate = (dateStr) => {
    // Konvertiert das Datum von DD.MM.YYYY zu YYYY-MM-DD für die interne Verarbeitung
    if (!dateStr) return '';
    if (dateStr.includes('-')) return dateStr; // Bereits im internen Format
    
    const parts = dateStr.split('.');
    if (parts.length !== 3) return dateStr;
    
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  const sortByDate = (data) => {
    return [...data].sort((a, b) => {
      const dateA = parseDate(a.datum);
      const dateB = parseDate(b.datum);
      
      return new Date(dateA) - new Date(dateB);
    });
  };

  // Verbesserte Version - Laden der gespeicherten Daten
  useEffect(() => {
    const loadSavedData = () => {
      if (projectId) {
        console.log('Loading data for project:', projectId);

        // Laden der Probedaten
        const savedProbedaten = localStorage.getItem(`probedaten_${projectId}`);
        if (savedProbedaten) {
          try {
            const parsedProbedaten = JSON.parse(savedProbedaten);
            if (parsedProbedaten && parsedProbedaten.length > 0) {
              setProbedaten(parsedProbedaten);
            }
          } catch (error) {
            console.error('Error loading probedaten:', error);
          }
        }

        // Laden der Szenen
        const savedScenes = localStorage.getItem(`scenes_${projectId}`);
        if (savedScenes) {
          try {
            const parsedScenes = JSON.parse(savedScenes);
            if (parsedScenes && parsedScenes.length > 0) {
              setScenes(parsedScenes);
            }
          } catch (error) {
            console.error('Error loading scenes:', error);
          }
        }

        // Laden der Zuordnungen
        const savedAssignments = localStorage.getItem(`assignments_${projectId}`);
        if (savedAssignments) {
          try {
            const parsedAssignments = JSON.parse(savedAssignments);
            if (parsedAssignments && parsedAssignments.length > 0) {
              setAssignments(parsedAssignments);
            }
          } catch (error) {
            console.error('Error loading assignments:', error);
          }
        }

        // Laden der Absenzen
        const savedAbsences = localStorage.getItem(`absences_${projectId}`);
        if (savedAbsences) {
          try {
            const parsedAbsences = JSON.parse(savedAbsences);
            if (parsedAbsences && parsedAbsences.length > 0) {
              setAbsences(parsedAbsences);
            }
          } catch (error) {
            console.error('Error loading absences:', error);
          }
        }

        // Laden der Team-Verfügbarkeit
        const savedTeamAvailability = localStorage.getItem(`teamAvailability_${projectId}`);
        if (savedTeamAvailability) {
          try {
            const parsedTeamAvailability = JSON.parse(savedTeamAvailability);
            if (parsedTeamAvailability && parsedTeamAvailability.length > 0) {
              setTeamAvailability(parsedTeamAvailability);
            }
          } catch (error) {
            console.error('Error loading team availability:', error);
          }
        }

        // Laden der ausgewählten Szenen
        const savedAusgewaehlteSzenen = localStorage.getItem(`ausgewaehlteSzenen_${projectId}`);
        if (savedAusgewaehlteSzenen) {
          try {
            const parsedAusgewaehlteSzenen = JSON.parse(savedAusgewaehlteSzenen);
            if (parsedAusgewaehlteSzenen && parsedAusgewaehlteSzenen.length > 0) {
              setAusgewaehlteSzenen(sortByDate(parsedAusgewaehlteSzenen));
            }
          } catch (error) {
            console.error('Error loading selected scenes:', error);
          }
        }
      }
    };

    loadSavedData();
  }, [projectId]);

  // Aktualisierung der Zeiteinheiten, wenn ein Probetermin ausgewählt wird
  useEffect(() => {
    if (selectedProbetermin && probedaten.length > 0) {
      // Finde alle Zeiteinheiten für den ausgewählten Probetermin
      const zeiten = probedaten
        .filter(probe => probe.datum === selectedProbetermin)
        .map(probe => ({
          id: probe.id,
          anfangszeit: probe.anfangszeit,
          endzeit: probe.endzeit,
          artDerProbe: probe.artDerProbe || ''
        }));
      
      setZeiteinheiten(zeiten);
      // Wenn Zeiteinheiten verfügbar sind, setze die erste als ausgewählt
      if (zeiten.length > 0) {
        setSelectedZeiteinheit(zeiten[0].id);
      } else {
        setSelectedZeiteinheit('');
      }
    } else {
      setZeiteinheiten([]);
      setSelectedZeiteinheit('');
    }
  }, [selectedProbetermin, probedaten]);
  // Zeiteinheit-Änderungen behandeln - nur Zurücksetzen, keine automatische Generierung
useEffect(() => {
  console.log("Zeiteinheiten-Auswahl geändert:", { selectedProbetermin, selectedZeiteinheit });
  
  // Vorschläge zurücksetzen bei Datums- oder Zeitänderung
  setProbenvorschlaege([]);
  
}, [selectedProbetermin, selectedZeiteinheit]);
  // Verbesserte Version - Speichern der ausgewählten Szenen
  useEffect(() => {
    const saveData = () => {
      if (projectId && ausgewaehlteSzenen && ausgewaehlteSzenen.length > 0) {
        localStorage.setItem(`ausgewaehlteSzenen_${projectId}`, JSON.stringify(ausgewaehlteSzenen));
      }
    };

    saveData();
  }, [ausgewaehlteSzenen, projectId]);

  // Hilfsfunktion: Überprüft Zeitüberschneidungen
  const checkTimeOverlap = (start1, end1, start2, end2) => {
    if (!start1 || !end1 || !start2 || !end2) return false;
    
    const [hours1, minutes1] = start1.split(':').map(Number);
    const [hours2, minutes2] = end1.split(':').map(Number);
    const [hours3, minutes3] = start2.split(':').map(Number);
    const [hours4, minutes4] = end2.split(':').map(Number);

    const time1 = hours1 * 60 + minutes1;
    const time2 = hours2 * 60 + minutes2;
    const time3 = hours3 * 60 + minutes3;
    const time4 = hours4 * 60 + minutes4;

    return !(time2 <= time3 || time1 >= time4);
  };

  // Hilfsfunktion: Prüft Verfügbarkeit eines Schauspielers
  const isActorAvailable = (actor, date, startTime, endTime) => {
    const absencesForActor = absences.filter(
      absence => absence.schauspieler === actor && absence.datum === formatDate(date)
    );

    return !absencesForActor.some(absence =>
      absence.anfangszeit && absence.endzeit
        ? checkTimeOverlap(startTime, endTime, absence.anfangszeit, absence.endzeit)
        : true // Wenn keine Zeitangaben in der Absenz sind, gilt der ganze Tag als gesperrt
    );
  };

  // Hilfsfunktion: Prüft Verfügbarkeit des Teams
  const getAvailableTeamMembers = (date, startTime, endTime) => {
    return teamAvailability
      .filter(availability => 
        availability.datum === formatDate(date) &&
        (!availability.anfangszeit || !availability.endzeit || 
          checkTimeOverlap(availability.anfangszeit, availability.endzeit, startTime, endTime))
      )
      .map(availability => availability.teamMitglied);
  };
// Neue Funktion: Absenzen für einen bestimmten Termin ermitteln
const getAbsencesForScene = (date, startTime, endTime) => {
  return absences.filter(absence => 
    absence.datum === date &&
    (!absence.anfangszeit || !absence.endzeit || 
      checkTimeOverlap(startTime, endTime, absence.anfangszeit, absence.endzeit))
  );
};
  // Proben-Eintrag löschen
  const deleteProbenEintrag = (index) => {
    if (window.confirm('Möchten Sie diesen Probeneintrag wirklich löschen?')) {
      setAusgewaehlteSzenen(prev => {
        const newSzenen = [...prev];
        newSzenen.splice(index, 1);
  
        if (newSzenen.length === 0) {
          localStorage.removeItem(`ausgewaehlteSzenen_${projectId}`);
        } else {
          localStorage.setItem(`ausgewaehlteSzenen_${projectId}`, JSON.stringify(newSzenen));
        }
  
        return newSzenen;
      });
    }
  };

  // Export als Excel
  const exportToCSV = () => {
    const csv = Papa.unparse(ausgewaehlteSzenen);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'probenplan.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

 // Vereinfachte Variante der Probenvorschläge generieren
  // Hilfsfunktion: Szene zur Auswahltabelle hinzufügen
  const selectScene = (scene) => {
    // Debuginformationen in die Konsole ausgeben
    console.log("Ausgewählter Termin:", selectedProbetermin);
    console.log("Ausgewählte Zeiteinheit ID:", selectedZeiteinheit);
    console.log("Verfügbare Zeiteinheiten:", zeiteinheiten);
    
    // Zeiteinheit aus dem Dropdown-Menü extrahieren
    const selectedOption = document.querySelector(`option[value="${selectedZeiteinheit}"]`);
    console.log("Ausgewählte Option:", selectedOption);
    
    if (selectedOption) {
      // Text aus dem ausgewählten Element extrahieren, z.B. "19:00 - 21:00 (Probe)"
      const optionText = selectedOption.textContent;
      console.log("Optionstext:", optionText);
      
      // Zeiten aus dem Text extrahieren
      const timeMatch = optionText.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
      let startTime = '', endTime = '', probeType = '';
      
      if (timeMatch && timeMatch.length >= 3) {
        startTime = timeMatch[1];
        endTime = timeMatch[2];
        
        // Probentyp extrahieren (falls vorhanden)
        const typeMatch = optionText.match(/\(([^)]+)\)/);
        if (typeMatch && typeMatch.length >= 2) {
          probeType = typeMatch[1];
        }
      }
      
      console.log("Extrahierte Zeiten:", startTime, endTime, probeType);
      
      console.log("Extrahierte Zeiten:", startTime, endTime, probeType);
      
// Eintrag erstellen
const displayDate = formatDate(selectedProbetermin);
const weekday = new Date(parseDate(selectedProbetermin)).toLocaleDateString('de-DE', { weekday: 'long' });
// Ermittle welche Schauspieler die Figuren in der Szene spielen
const beteiligteSchauspieler = [];

// Füge Schauspieler für Hauptfiguren hinzu
scene.hauptfiguren.forEach(figur => {
  const schauspieler = assignments.find(a => a.figur === figur)?.schauspieler;
  if (schauspieler && !beteiligteSchauspieler.includes(schauspieler)) {
    beteiligteSchauspieler.push(schauspieler);
  }
});

// Füge Schauspieler für Nebenfiguren hinzu
scene.nebenfiguren.forEach(figur => {
  const schauspieler = assignments.find(a => a.figur === figur)?.schauspieler;
  if (schauspieler && !beteiligteSchauspieler.includes(schauspieler)) {
    beteiligteSchauspieler.push(schauspieler);
  }
});

// Ermittle, welche der beteiligten Schauspieler abwesend sind
const relevantAbsences = absences.filter(absence => 
  beteiligteSchauspieler.includes(absence.schauspieler) && 
  absence.datum === displayDate &&
  (!absence.anfangszeit || !absence.endzeit || 
    checkTimeOverlap(startTime, endTime, absence.anfangszeit, absence.endzeit))
);

// Nur die Namen der abwesenden Schauspieler ohne "kein Grund angegeben"
const absencesText = relevantAbsences.map(absence => 
  absence.grund ? `${absence.schauspieler} (${absence.grund})` : absence.schauspieler
).join(', ');

// Beteiligten-Text generieren
const beteiligteText = beteiligteSchauspieler.join(', ');

const neuerEintrag = {
  id: Date.now().toString(),
  datum: displayDate,
  wochentag: weekday,
  probebeginn: startTime,
  probeende: endTime,
  szene: scene.szene,
  kurzbeschreibung: scene.beschreibung,
  beteiligte: beteiligteText,
  absenzen: absencesText,
  bemerkungen: scene.statusText,
  artDerProbe: probeType
};
      
      console.log("Neuer Eintrag:", neuerEintrag);
      
      // Eintrag zur Liste hinzufügen
      const neueAusgewaehlteSzenen = [...ausgewaehlteSzenen, neuerEintrag];
      setAusgewaehlteSzenen(sortByDate(neueAusgewaehlteSzenen));
      localStorage.setItem(`ausgewaehlteSzenen_${projectId}`, JSON.stringify(neueAusgewaehlteSzenen));
      
      alert("Szene erfolgreich hinzugefügt.");
    } else {
      // Fallback: Einfach direkt nach Zeiteinheit suchen
      const zeit = zeiteinheiten.find(z => String(z.id) === String(selectedZeiteinheit));
      
      if (zeit) {
        console.log("Zeiteinheit gefunden (als Fallback):", zeit);
        
        const displayDate = formatDate(selectedProbetermin);
        const weekday = new Date(parseDate(selectedProbetermin)).toLocaleDateString('de-DE', { weekday: 'long' });
        // Absenzen für diesen Termin ermitteln
        const relevantAbsences = getAbsencesForScene(displayDate, zeit.anfangszeit, zeit.endzeit);
        const absencesText = relevantAbsences.map(absence => 
          `${absence.schauspieler} (${absence.grund || 'kein Grund angegeben'})`
        ).join(', ');
        const neuerEintrag = {
          id: Date.now().toString(),
          datum: displayDate,
          wochentag: weekday,
          probebeginn: zeit.anfangszeit || '',
          probeende: zeit.endzeit || '',
          szene: scene.szene,
          kurzbeschreibung: scene.beschreibung,
          beteiligte: scene.beteiligte,
          absenzen: absencesText,
          bemerkungen: scene.statusText,
          artDerProbe: zeit.artDerProbe || ''
        };
        
        console.log("Neuer Eintrag (Fallback):", neuerEintrag);
        
        const neueAusgewaehlteSzenen = [...ausgewaehlteSzenen, neuerEintrag];
        setAusgewaehlteSzenen(sortByDate(neueAusgewaehlteSzenen));
        localStorage.setItem(`ausgewaehlteSzenen_${projectId}`, JSON.stringify(neueAusgewaehlteSzenen));
        
        alert("Szene erfolgreich hinzugefügt (Fallback).");
      } else {
        alert("Fehler: Die ausgewählte Zeiteinheit konnte nicht gefunden werden! Bitte wählen Sie erneut aus.");
        console.error("Zeiteinheit nicht gefunden:", selectedZeiteinheit);
      }
    }
  };
  // Export als iCal
  const exportToCalendar = () => {
    const icalContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Probeplaner//DE',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH'
    ];

    ausgewaehlteSzenen.forEach(szene => {
      const datum = parseDate(szene.datum);
      const datumTeile = datum.split('-');
      const startzeit = szene.probebeginn.replace(':', '');
      const endzeit = szene.probeende.replace(':', '');
      
      const startDate = `${datumTeile.join('')}T${startzeit}00`;
      const endDate = `${datumTeile.join('')}T${endzeit}00`;

      icalContent.push(
        'BEGIN:VEVENT',
        `DTSTART;TZID=Europe/Berlin:${startDate}`,
        `DTEND;TZID=Europe/Berlin:${endDate}`,
        `SUMMARY:Probe: ${szene.szene}`,
       `DESCRIPTION:${szene.kurzbeschreibung}\\n\\nBeteiligte: ${szene.beteiligte}\\n\\nAnwesend: ${szene.anwesend}\\n\\nAbsenzen: ${szene.absenzen || 'Keine'}\\n\\nBemerkungen: ${szene.bemerkungen}`,
        'SEQUENCE:0',
        `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z`,
        `UID:${Date.now()}-${Math.random().toString(36).substr(2, 9)}@probeplaner`,
        'END:VEVENT'
      );
    });

    icalContent.push('END:VCALENDAR');

    const blob = new Blob([icalContent.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'probenplan.ics';
    link.click();
  };

  // Sortieren der Tabelle
  const sortTable = (field) => {
    setAusgewaehlteSzenen(prev => {
      const sorted = [...prev].sort((a, b) => {
        if (field === 'datum') {
          return new Date(parseDate(a.datum)) - new Date(parseDate(b.datum));
        }
        if (typeof a[field] === 'string') {
          return a[field].localeCompare(b[field]);
        }
        return a[field] - b[field];
      });
      return sorted;
    });
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">
        Szenenvorschlag
      </h2>
      
      {/* Probetermin Auswahl */}
      <div className="mb-6 flex flex-col space-y-4">
        <div className="flex items-center space-x-4">
          <select
            value={selectedProbetermin}
            onChange={(e) => setSelectedProbetermin(e.target.value)}
            className="border p-2 flex-grow"
          >
            <option value="">Probetermin auswählen</option>
            {/* Gruppiere Termine nach Datum */}
            {[...new Set(probedaten.map(termin => termin.datum))].map((datum) => (
              <option key={datum} value={datum}>
                {formatDate(datum)}
              </option>
            ))}
          </select>
        </div>
        
        {/* Zeiteinheit-Auswahl */}
        {zeiteinheiten.length > 0 && (
          <div className="flex items-center space-x-4">
            <select
              value={selectedZeiteinheit}
              onChange={(e) => setSelectedZeiteinheit(e.target.value)}
              className="border p-2 flex-grow"
            >
              <option value="">Zeiteinheit auswählen</option>
              {zeiteinheiten.map((zeit) => (
                <option key={zeit.id} value={zeit.id}>
                  {zeit.anfangszeit} - {zeit.endzeit} {zeit.artDerProbe ? `(${zeit.artDerProbe})` : ''}
                </option>
              ))}
            </select>

            <button
  onClick={() => {
    console.log("Button geklickt");
    // Vorschläge zurücksetzen
    setProbenvorschlaege([]);
    
    try {
      if (selectedProbetermin && selectedZeiteinheit) {
        const selectedProbe = probedaten.find(probe => String(probe.id) === String(selectedZeiteinheit));
        if (selectedProbe) {
          console.log("Generiere Vorschläge für:", selectedProbe);
          
          // Vollständige Generierungslogik mit Absenzen-Prüfung
          const vorschlaege = scenes.map(scene => {
            // Ermittle verfügbare Haupt- und Nebenfiguren
            const figurenVerfuegbarkeit = {
              hauptfiguren: scene.hauptfiguren.map(figur => {
                const schauspieler = assignments.find(ass => ass.figur === figur)?.schauspieler;
                const verfuegbar = schauspieler && isActorAvailable(
                  schauspieler,
                  selectedProbe.datum,
                  selectedProbe.anfangszeit,
                  selectedProbe.endzeit
                );
                return { figur, schauspieler, verfuegbar };
              }),
              nebenfiguren: scene.nebenfiguren.map(figur => {
                const schauspieler = assignments.find(ass => ass.figur === figur)?.schauspieler;
                const verfuegbar = schauspieler && isActorAvailable(
                  schauspieler,
                  selectedProbe.datum,
                  selectedProbe.anfangszeit,
                  selectedProbe.endzeit
                );
                return { figur, schauspieler, verfuegbar };
              })
            };

            // Status und Details ermitteln
            const verfuegbareHauptfiguren = figurenVerfuegbarkeit.hauptfiguren.filter(f => f.verfuegbar);
            const verfuegbareNebenfiguren = figurenVerfuegbarkeit.nebenfiguren.filter(f => f.verfuegbar);
            const alleHauptfigurenVerfuegbar = verfuegbareHauptfiguren.length === scene.hauptfiguren.length;
            const mindestensEineHauptfigurVerfuegbar = verfuegbareHauptfiguren.length > 0;

            // Verfügbare Teammitglieder ermitteln
            const verfuegbaresTeam = getAvailableTeamMembers(
              selectedProbe.datum,
              selectedProbe.anfangszeit,
              selectedProbe.endzeit
            );

            let status, statusText;
            if (alleHauptfigurenVerfuegbar) {
              status = 'gruen';
              statusText = 'Optimal: Alle Hauptfiguren verfügbar';
            } else if (mindestensEineHauptfigurVerfuegbar) {
              status = 'orange';
              statusText = 'Möglich: Einige Hauptfiguren verfügbar';
            } else {
              status = 'rot';
              statusText = 'Nicht möglich: Keine Hauptfiguren verfügbar';
            }

            // Prioritätswert für Sortierung berechnen
            const prioritaet = (
              (verfuegbareHauptfiguren.length * 2) +
              (verfuegbareNebenfiguren.length) +
              (verfuegbaresTeam.length * 0.5)
            );

            return {
              ...scene,
              status,
              statusText,
              prioritaet,
              verfuegbareHauptfiguren: verfuegbareHauptfiguren.map(f => f.figur),
              fehlendeHauptfiguren: figurenVerfuegbarkeit.hauptfiguren
                .filter(f => !f.verfuegbar)
                .map(f => f.figur),
              verfuegbareNebenfiguren: verfuegbareNebenfiguren.map(f => f.figur),
              fehlendeNebenfiguren: figurenVerfuegbarkeit.nebenfiguren
                .filter(f => !f.verfuegbar)
                .map(f => f.figur),
              verfuegbaresTeam,
              beteiligte: [
                ...verfuegbareHauptfiguren,
                ...verfuegbareNebenfiguren
              ].map(f => f.schauspieler).filter((v, i, a) => a.indexOf(v) === i).join(', ')
            };
          });

          // Vorschläge filtern und sortieren
          const gueltigeVorschlaege = vorschlaege
            .filter(vorschlag => vorschlag.status !== 'rot')
            .sort((a, b) => {
              if (a.status === 'gruen' && b.status !== 'gruen') return -1;
              if (a.status !== 'gruen' && b.status === 'gruen') return 1;
              return b.prioritaet - a.prioritaet;
            });

          console.log("Generierte Vorschläge:", vorschlaege.length);
          console.log("Gültige Vorschläge nach Filterung:", gueltigeVorschlaege.length);
          setProbenvorschlaege(gueltigeVorschlaege);
        }
      }
    } catch (error) {
      console.error("Fehler:", error);
      alert("Fehler bei der Generierung: " + error.message);
    }
  }}
  className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 font-bold"
  disabled={!selectedZeiteinheit}
>
  Szenenvorschläge generieren
</button>
          </div>
        )}
      </div>

      {/* Vorschläge Tabelle */}
      {probenvorschlaege.length > 0 && (
        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Verfügbare Szenen</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border">
              <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Szene</th>
                <th className="border p-2">Beschreibung</th>
                <th className="border p-2">Status</th>
                <th className="border p-2">Hauptfiguren</th>
                <th className="border p-2">Nebenfiguren</th>
                <th className="border p-2">Team verfügbar</th>
                <th className="border p-2">Aktionen</th>
              </tr>
              </thead>
              <tbody>
                {probenvorschlaege.map((vorschlag, index) => (
                  <tr 
                    key={index} 
                    className={
                      vorschlag.status === 'gruen' 
                        ? 'bg-green-100' 
                        : vorschlag.status === 'orange' 
                        ? 'bg-orange-100' 
                        : ''
                    }
                  >
                    <td className="border p-2">{vorschlag.szene}</td>
                    <td className="border p-2">{vorschlag.beschreibung}</td>
                    <td className="border p-2">{vorschlag.statusText}</td>
                    <td className="border p-2">
                      Verfügbar: {vorschlag.verfuegbareHauptfiguren.join(', ')}
                      {vorschlag.fehlendeHauptfiguren.length > 0 && (
                        <div className="text-red-500">
                          Fehlend: {vorschlag.fehlendeHauptfiguren.join(', ')}
                        </div>
                      )}
                    </td>
                    <td className="border p-2">
                      Verfügbar: {vorschlag.verfuegbareNebenfiguren.join(', ')}
                      {vorschlag.fehlendeNebenfiguren.length > 0 && (
                        <div className="text-red-500">
                          Fehlend: {vorschlag.fehlendeNebenfiguren.join(', ')}
                        </div>
                      )}
                    </td>
                    <td className="border p-2">
                      {vorschlag.verfuegbaresTeam.length > 0 
                        ? vorschlag.verfuegbaresTeam.join(', ')
                        : <span className="text-gray-500">Keine Teammitglieder verfügbar</span>
                      }
                    </td>
                    <td className="border p-2">
                      <button
                        onClick={() => selectScene(vorschlag)}
                        className="bg-blue-500 text-white p-1 rounded hover:bg-blue-600"
                      >
                        Auswählen
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Ausgewählte Szenen Tabelle */}
      <div>
        <div className="mb-4 flex justify-between items-center">
          <h3 className="text-xl font-semibold">Probenplanung</h3>
          <div className="flex space-x-2">
            <button
              onClick={exportToCSV}
              className="bg-green-500 text-white p-2 rounded hover:bg-green-600"
            >
              Als Excel exportieren
            </button>
            <button
              onClick={exportToCalendar}
              className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
            >
              Kalender exportieren
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('datum')}>
                  Datum ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('wochentag')}>
                  Wochentag ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('probebeginn')}>
                  Probebeginn ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('probeende')}>
                  Probeende ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('szene')}>
                  Szene ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('kurzbeschreibung')}>
                  Beschreibung ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('beteiligte')}>
                  Beteiligte ↕
                </th>
                <th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('absenzen')}>
  Absenzen ↕
</th>
<th className="border p-2 cursor-pointer hover:bg-gray-300" onClick={() => sortTable('bemerkungen')}>
  Bemerkungen ↕
</th>
                <th className="border p-2">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {ausgewaehlteSzenen.map((szene, index) => (
                <tr key={index}>
                  <td className="border p-2">{szene.datum}</td>
                  <td className="border p-2">{szene.wochentag}</td>
                  <td className="border p-2">{szene.probebeginn}</td>
                  <td className="border p-2">{szene.probeende}</td>
                  <td className="border p-2">{szene.szene}</td>
                  <td className="border p-2">{szene.kurzbeschreibung}</td>
                  <td className="border p-2">{szene.beteiligte}</td>
                  <td className="border p-2 text-red-600">{szene.absenzen || 'Keine Absenzen'}</td>
                  <td className="border p-2">{szene.bemerkungen}</td>
                  <td className="border p-2">
                    <button
                      onClick={() => deleteProbenEintrag(index)}
                      className="bg-red-500 text-white p-1 rounded hover:bg-red-600"
                    >
                      Löschen
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SzenenvorschlagPage;